"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("what-input");

var _RawButton = _interopRequireDefault(require("./RawButton.styles"));

/* eslint-disable jsx-a11y/no-static-element-interactions */
var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** If click events are allowed to propagate up the DOM tree. */
  canPropagate: _propTypes["default"].bool,

  /** Body content of the button. */
  children: _propTypes["default"].node.isRequired,

  /** If the visual focus ring should be displayed with an inset style. */
  hasInsetFocusStyle: _propTypes["default"].bool,

  /** If the button is in an "active" or "selected" state. */
  isActive: _propTypes["default"].bool,

  /** If the button is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** Callback to be executed when the button is clicked or activated by keyboard. Typically required. */
  onClick: _propTypes["default"].func,

  /** Value for role attribute to override the default of "button". */
  role: _propTypes["default"].string,

  /** Value for tabindex attribute to override the default of 0. */
  tabIndex: _propTypes["default"].number
};
var defaultProps = {
  a11yText: null,
  canPropagate: true,
  isActive: null,
  isDisabled: false,
  hasInsetFocusStyle: false,
  onClick: function onClick() {},
  role: "button",
  tabIndex: null
};

var isTriggerKey = function isTriggerKey(key) {
  return [" ", "Enter"].includes(key);
};

var _StyledSpan = (0, _styledComponents["default"])("span").withConfig({
  displayName: "RawButton___StyledSpan",
  componentId: "gvarda-0"
})(["", ""], _RawButton["default"]);

var RawButton = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      canPropagate = props.canPropagate,
      children = props.children,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      onClick = props.onClick,
      tabIndex = props.tabIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "canPropagate", "children", "isActive", "isDisabled", "onClick", "tabIndex"]);

  var rawButtonRef = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      hasForcedFocus = _React$useState2[0],
      setHasForcedFocus = _React$useState2[1];

  _react["default"].useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        setHasForcedFocus(true);
        rawButtonRef.current.focus();
      }
    };
  });

  var handleClick = function handleClick(event) {
    setHasForcedFocus(false);
    if (!canPropagate) event.stopPropagation();
    if (!isDisabled) onClick(event);
  };

  function handleBlur(event) {
    if (moreProps.onBlur) moreProps.onBlur(event);
    setHasForcedFocus(false);
  }

  var handleKeyDown = function handleKeyDown(event) {
    // Prevent scrolling the page with a spacerbar keypress
    // Prevent submitting forms in IE/Edge with and enter keypress
    if (isTriggerKey(event.key)) event.preventDefault();
    var shouldHandle = canPropagate || event.target === rawButtonRef.current;
    if (shouldHandle && moreProps.onKeyDown) moreProps.onKeyDown(event);
  };

  var handleKeyUp = function handleKeyUp(event) {
    var shouldHandle = canPropagate || event.target === rawButtonRef.current;

    if (!isDisabled && shouldHandle && isTriggerKey(event.key)) {
      onClick(event);
    }

    if (shouldHandle && moreProps.onKeyUp) moreProps.onKeyUp(event);
  };

  var bestTabIndex = isDisabled && tabIndex === null ? -1 : tabIndex || 0;
  return /*#__PURE__*/_react["default"].createElement(_StyledSpan, (0, _extends2["default"])({
    "aria-pressed": isActive,
    "data-pka-anchor": "raw-button",
    tabIndex: bestTabIndex,
    "aria-label": a11yText
  }, moreProps, {
    "aria-disabled": isDisabled,
    "data-has-forced-focus": hasForcedFocus || null,
    isActive: isActive,
    isDisabled: isDisabled,
    onBlur: handleBlur,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: rawButtonRef
  }), children);
});

RawButton.displayName = "RawButton";
RawButton.propTypes = propTypes;
RawButton.defaultProps = defaultProps;
var _default = RawButton;
exports["default"] = _default;
//# sourceMappingURL=RawButton.js.map